<template>
  <div class="user_detail">
    <UserHead/>
    <UserNavi/>
    <div class="user_detail_main">
      <div class="user_detail_one">
        <div class="user_detail_left">
          用户名
        </div>
        <div class="user_detail_right">
          {{user.username}}
        </div>
      </div>
      <div class="user_detail_one">
        <div class="user_detail_left">
          用户等级
        </div>
        <div class="user_detail_right">
          {{role.role_name}}
        </div>
      </div>
      <div class="user_detail_one">
        <div class="user_detail_left">
          电话
        </div>
        <div class="user_detail_right">
          {{user.phone}}
        </div>
      </div>
      <div class="user_detail_one">
        <div class="user_detail_left">
          邮箱
        </div>
        <div class="user_detail_right">
          {{user.email || '无'}}
        </div>
      </div>
      <div class="user_detail_one">
        <div class="user_detail_left">
          上次登录
        </div>
        <div class="user_detail_right">
          {{new Date(user.lasttime*1000).toLocaleString()}}
        </div>
      </div>
    </div>
    <div class="user_detail_bottom" v-if="browserType!==1">
      <div class="user_detail_logout" @click="logout">退出登录</div>
    </div>
  </div>
</template>

<script>
  import { weblogout,bindUserRecommend,getUserRecommendCount } from '../../api/api'
  import { removeStorage,getJsonStorage } from "../../util/storage";
  import { getBrowserType } from "../../util/common";
  import UserHead from './head'
  import UserNavi from './navi'

  export default {
    name: "IndexUser",
    components: {
      UserHead,
      UserNavi
    },
    data() {
      return {
        browserType: getBrowserType(),
        user: getJsonStorage('openai_user') || {},
        privileges:{},
        role:{}
      }
    },
    mounted(){
      if(this.user && this.user.user_id) {
        let privileges = getJsonStorage('openai_privileges');
        this.privileges = privileges;
        this.role = privileges.role;
      }else{
        this.$router.push('/index/login');
      }
    },
    methods: {
      toLogin(){
        this.$router.push('/index/login');
      },
      logout(){
        weblogout().then(res => {
          removeStorage("openai_user");
          removeStorage("openai_privileges");
          removeStorage("openai_missions");
          this.$router.push('/');
        })
      }
    }
  }
</script>

<style scoped>
  .user_detail {
    position:absolute;
    top:6vh;
    width:100%;
    height:92vh;
  }
  .user_detail_main {
    width:94%;
    height:76vh;
    margin: 1vh 3%;
    border: 1px solid #ccc;
    border-radius: 1rem;
  }
  .user_detail_one {
    width:90%;
    margin: 0 5%;
    height:5vh;
    line-height:5vh;
    border-bottom:1px solid #eee;
  }
  .user_detail_left {
    width:23%;
    padding-left:2%;
    float:left;
    margin: 0;
    height:5vh;
    line-height:5vh;
    text-align:left;
    font-size:.85rem;
    color: #999;
  }
  .user_detail_right {
    width:70%;
    padding-left:5%;
    float:left;
    margin: 0;
    height:5vh;
    line-height:5vh;
    font-size:.95rem;
    text-align:left;
  }
  .user_detail_bottom {
    position:absolute;
    bottom:5vh;
    left: 0;
    width:100%;
    text-align:center;
  }
  .user_detail_logout {
    margin: 0 auto;
    height:6vh;
    line-height:6vh;
    width:70%;
    background-color:#eee;
    color:#888;
    border:none;
    border-radius:.5rem;
    font-size:.9rem;
  }
  .recommend_counts {
    color:grey;
    font-size:.8rem;
    margin-left:1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/detail.vue